<template>
  <div v-click-outside="collapse">
    <b-navbar toggleable="lg" class="Nav fixed-top">
      <b-navbar-brand to="/">
        <b-img
          src="../../assets/common/newLogo.png"
          fluid
          alt="MAD PODŁOGI"
        ></b-img>
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse" id="toggle"></b-navbar-toggle>
      <b-collapse
        id="nav-collapse"
        is-nav
        class="navItems"
        align="center"
        :justified="truBoolHack"
        align-content="center"
      >
        <b-navbar-nav :justified="truBoolHack">
          <b-nav-item to="/aktualnosci"
            ><router-link to="/aktualnosci" class="navItem"
              >AKTUALNOŚCI</router-link
            ></b-nav-item
          >
          <b-nav-item to="/kolekcja"
            ><router-link to="/kolekcja" class="navItem"
              >KOLEKCJE</router-link
            ></b-nav-item
          >

          <b-nav-item-dropdown class="navDropdown" right>
            <template v-slot:button-content style="color:black">
              OFERTA
            </template>
            <b-dropdown-item to="/oleje">OLEJE</b-dropdown-item>
            <b-dropdown-item to="/podlogi">PODŁOGI</b-dropdown-item>
            <b-dropdown-item to="/pielegnacja">PIELĘGNACJA</b-dropdown-item>
            <b-dropdown-item to="/handmade">HANDMADE</b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item to="/baza-wiedzy"
            ><router-link to="/baza-wiedzy" class="navItem"
              >BAZA WIEDZY</router-link
            ></b-nav-item
          >
          <b-nav-item to="/realizacje"
            ><router-link to="/realizacje" class="navItem"
              >REALIZACJE</router-link
            ></b-nav-item
          >
          <b-nav-item to="/gdzie-nas-znalezc"
            ><router-link to="/gdzie-nas-znalezc" class="navItem"
              >GDZIE NAS ZNALEŹĆ</router-link
            ></b-nav-item
          >
          <b-nav-item to="/kontakt"
            ><router-link to="/kontakt" class="navItem"
              >KONTAKT</router-link
            ></b-nav-item
          >
          <b-nav-item href="https://drive.google.com/file/d/1p9DXPXs8wMGxRFg6FbJCt7XhU01pc6JG/view" target="_blank" 
            ><a href="https://drive.google.com/file/d/1p9DXPXs8wMGxRFg6FbJCt7XhU01pc6JG/view" class="navItem navItemBold" target="_blank"
              >Katalog 2020/2021</a
            ></b-nav-item
          >
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
// eslint-disable-next-line prettier/prettier
import vClickOutside from 'v-click-outside'
export default {
  directives: {
    clickOutside: vClickOutside.directive
  },
  data() {
    return {
      truBoolHack: true //there was warning for justified="true" in navbar
    };
  },
  methods: {
    collapse: function() {
      let element = document.getElementById("nav-collapse");
      if (element.classList.contains("show"))
        document.getElementById("toggle").click();
    }
  }
};
</script>

<style scoped>
.Nav {
  background: #ffffff;
}
.navItems {
  justify-content: flex-end;

}
.navItemBold {
  font-size: 1.3em;
  font-weight: bold;
}


</style>
